export default __webpack_public_path__ + "static/media/dynamic-allround-arc-2.0cd4b4fb.jpg";